/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 07/03/22
 */

import { Box, Textarea, TextareaProps } from '@chakra-ui/react';
import React from 'react';

const ResizingTextarea = (props: TextareaProps) => {
    const { value, ...textareaProps } = props;
    return (
        <Box display="grid">
            <Textarea
                {...textareaProps}
                value={value}
                resize="none"
                overflow="hidden"
                gridArea="1 / 1 / 2 / 2"
                h="full"
            />
            <Textarea as="div" whiteSpace="pre-wrap" visibility="hidden" height="unset" gridArea="1 / 1 / 2 / 2" id="">
                {value}
                <br />
            </Textarea>
        </Box>
    );
};

export default ResizingTextarea;
